import { motion, AnimatePresence } from "framer-motion";

interface BookmarkTooltipProps {
  visible: boolean;
}

export function BookmarkTooltip({ visible }: BookmarkTooltipProps) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 10, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -5, scale: 0.95 }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 25,
          }}
          className="absolute -top-28 left-1/2 -translate-x-1/2 z-20 pointer-events-none"
        >
          <div className="relative">
            {/* Tooltip bubble */}
            <motion.div
              className="px-4 py-3 bg-white/50 backdrop-blur-sm border border-white/80 w-48 text-gray-800 text-sm font-medium rounded-lg shadow-2xl whitespace-normal relative"
              animate={{
                y: [0, -4, 0],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <span className="flex items-start gap-1.5">
                <span className="text-amber-500">✨</span>
                <span>
                  At the end you can save or share feedback on your bookmarks
                </span>
              </span>
              {/* Circle indicator below - inside the bubble div so it animates together */}
              <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-2.5 h-2.5 bg-white backdrop-blur-sm border border-white/50 rounded-full shadow-sm" />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
